import parse, {
  attributesToProps,
  domToReact,
  Element,
} from 'html-react-parser';
import { InboxMessage } from 'modules/types/Inbox';
import { NavigationAndActionClose } from 'modules/ui/icons';
import { HeaderLogoSm } from 'modules/ui/logo';
import { ToggleButton } from 'modules/ui/toggleButton';
import {
  StyledCloseButtonContainer,
  StyledFooterLabelContainer,
  StyledHeaderLabelContainer,
  StyledHeaderLogoContainer,
  StyledInboxMessageDisplayContainer,
  StyledInboxMessageDisplayContent,
  StyledInboxMessageDisplayFooter,
  StyledInboxMessageDisplayHeader,
  StyledInboxMessageDisplayLabel,
  StyledInboxMessageDisplayTitle,
} from './styled';

export interface InboxMessageDisplayProps {
  message?: InboxMessage;
  className?: string;
  onClose?: () => void;
}

export const InboxMessageDisplay: React.FC<InboxMessageDisplayProps> = ({
  message,
  className,
  onClose,
}) => (
  <StyledInboxMessageDisplayContainer className={className}>
    {message ? (
      <>
        <StyledInboxMessageDisplayHeader>
          <StyledHeaderLogoContainer>
            <HeaderLogoSm />
          </StyledHeaderLogoContainer>
          <StyledHeaderLabelContainer>
            <StyledInboxMessageDisplayLabel>
              {message.time}
            </StyledInboxMessageDisplayLabel>
            <StyledInboxMessageDisplayLabel>
              {message.date}
            </StyledInboxMessageDisplayLabel>
          </StyledHeaderLabelContainer>
          <StyledCloseButtonContainer>
            <ToggleButton
              onClick={onClose}
              icon={<NavigationAndActionClose />}
            />
          </StyledCloseButtonContainer>
        </StyledInboxMessageDisplayHeader>
        <div>
          <StyledInboxMessageDisplayLabel>
            {message.sender}
          </StyledInboxMessageDisplayLabel>
          <StyledInboxMessageDisplayTitle>
            {message.title}
          </StyledInboxMessageDisplayTitle>
          <StyledInboxMessageDisplayContent>
            {parse(message.content, {
              replace: (domNode) => {
                if (domNode instanceof Element && domNode.name === 'a') {
                  const props = attributesToProps(domNode.attribs);
                  return (
                    <a target="_blank" {...props}>
                      {domToReact(domNode.children)}
                    </a>
                  );
                }
                return domNode;
              },
            })}
          </StyledInboxMessageDisplayContent>
        </div>
        <StyledInboxMessageDisplayFooter>
          <StyledFooterLabelContainer>
            <StyledInboxMessageDisplayLabel>
              {message.time}
            </StyledInboxMessageDisplayLabel>
            <StyledInboxMessageDisplayLabel>
              {message.date}
            </StyledInboxMessageDisplayLabel>
          </StyledFooterLabelContainer>
        </StyledInboxMessageDisplayFooter>
      </>
    ) : (
      <></>
    )}
  </StyledInboxMessageDisplayContainer>
);
